// extracted by mini-css-extract-plugin
export default {"header":"app-header_header__joE2Z","nav":"app-header_nav__0JKUD","left":"app-header_left__0hgo-","right":"app-header_right__8LdWU"};